import { render, staticRenderFns } from "./gtr-page.vue?vue&type=template&id=8a0561d4&scoped=true"
import script from "./gtr-page.ts?vue&type=script&lang=ts&external"
export * from "./gtr-page.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-page.vue?vue&type=style&index=0&id=8a0561d4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0561d4",
  null
  
)

export default component.exports